exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clothing-loss-modal__item {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-loss-modal__label {\r\n  color: #666666;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.clothing-loss-modal__value {\r\n  color: #333333;\r\n  font-size: 1rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/modals/clothing-loss-modal.component.css
// module id = ../../../../../src/app/modals/clothing-loss-modal.component.css
// module chunks = main